// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const DiagramGenerator: MarkdocTagRegistration = {
  tag: 'diagram-generator',
  component: 'DiagramGenerator',
  attributes: {
    type: {type: String, required: false, default: 'overview'},
  },
};
